import { Box, Link } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import CodeSnippet from "../../../components/CodeSnippet";
import ContentWrap from "../../../DocLayout/Content/Index";
import {
  APP_DEPOSIT__RECORD,
  APP_DEPOSIT__RECORD_LIST,
  APP_ORDERRECORD,
  CREATE_APP_AORDER_EPOSIT_ADDRESS,
  CREATE_APP_DEPOSIT__ADDRESS,
  TELEGRAM_SUPPORT_URL,
} from "../../../config";
import { Trans } from "react-i18next";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { codeMap } from "@/PageCodeComponents/MerchantAPPModelAPI";
import PostRequest from "@/components/PostRequest";
import InvoiceAPI from "@/PageComponents/InvoiceAPI";
export default function Index({
  url: CREATE_APP_AORDER_EPOSIT_ADDRESS_,
  url_: APP_ORDERRECORD_,
  url_1: CREATE_APP_DEPOSIT__ADDRESS_,
  url_2: APP_DEPOSIT__RECORD_,
  url_3: APP_DEPOSIT__RECORD_LIST_,
}: {
  url: string;
  url_: string;
  url_1: string;
  url_2: string;
  url_3: string;
}) {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const app_order_deposit_address = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "address": "0x9aBDDCE1EE18D1857C0653EB4a3Fa9d9E0dcd584",
      "amount": "0.008552856654122477",
      "memo": "",
      "checkoutUrl": "https://i.ccpayment.com/xxx",
      "confirmsNeeded": 50  }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
      "bytes"
      "crypto/hmac"
      "crypto/sha256"
      "encoding/hex"
      "fmt"
      "io"
      "net/http"
      "time"
  )
  
  func main() {
  
      appId := "*** your appId ***"
      appSecret := "*** your appSecret ***"
  
      // With request params
  
      path := "${CREATE_APP_AORDER_EPOSIT_ADDRESS_}"
      args := []byte(${'`{"coinId": 1280,"price": "1","orderId": "testorderid1111","chain": "POLYGON"}`'})
  
      //sign
      timestamp := time.Now().Unix()
  
      signText := fmt.Sprintf("%s%d", appId, timestamp)
      if len(args) != 0 {
          signText = fmt.Sprintf("%s%s", signText, args)
      }
  
      h := hmac.New(sha256.New, []byte(appSecret))
      h.Write([]byte(signText))
      sign := hex.EncodeToString(h.Sum(nil)[:])
  
      fmt.Printf("Sign: %s", sign)
  
      // Making API call
      client := http.Client{}
      request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
      request.Header.Set("Appid", appId)
      request.Header.Set("Sign", sign)
      request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
      resp, _ := client.Do(request)
  
      defer resp.Body.Close()
      respBytes, _ := io.ReadAll(resp.Body)
      fmt.Printf("Resp: %s", respBytes)
  }
  
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${CREATE_APP_AORDER_EPOSIT_ADDRESS_}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("coinId", 1280);
    map.put("price", "1");
    map.put("orderId", "testorderid1111");
    map.put("chain", "POLYGON");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
      responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
      tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
      hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${CREATE_APP_AORDER_EPOSIT_ADDRESS_}"
  content = {
    "coinId": 1280,
    "price": "1",
    "orderId": str(int(time.time())),
    "chain": "POLYGON",
    # "generateCheckoutURL": True,
    # "product": "test",
    # "fiatId": "1033",
    # "expiredAt": int(time.time()) + 10000,
    # "buyerEmail": "",
    # "returnUrl": "",
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  
  const path = "${CREATE_APP_AORDER_EPOSIT_ADDRESS_}";
  const args = JSON.stringify({
    "coinId": 1280,
    "price": "1",
    "orderId": "testorderid1111",
    "chain": "POLYGON",
  });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
    $app_id = "*** your app_id ***";
    $app_secret = "*** your app_secret ***";
    $url = "${CREATE_APP_AORDER_EPOSIT_ADDRESS_}";
    $content = [ "coinId"=> 1280,
      "price"=> "1",
      "orderId"=> "testorderid111133",
      "chain"=> "POLYGON"];
  
    $timestamp = time();
    $body = json_encode($content);
    $sign_text = $app_id . $timestamp;
    if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
    } else {
    $body = "";
    }
  
    $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
    $data = array(
    "headers" => array(
      "Content-Type: application/json;charset=utf-8",
      "Appid: " . $app_id,
      "Sign: " . $server_sign,
      "Timestamp: " . $timestamp
    ),
    "body" => $body
    );
  
    $ch = curl_init();
    curl_setopt($ch, CURLOPT_URL, $url);
    curl_setopt($ch, CURLOPT_POST, true);
    curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
    curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
    $response = curl_exec($ch);
    curl_close($ch);
  
    $result = json_decode($response, true);
    print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const app_order_info = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "amountToPay": "0.008552856654122477",
      "coinId": 1329,
      "coinSymbol": "MATIC",
      "chain": "POLYGON",
      "toAddress": "0x9abddce1ee18d1857c0653eb4a3fa9d9e0dcd584",
      "createAt": 1710233933,
      "rate": "1.1692",
      "fiatId": 1033,
      "fiatSymbol": "USD",
      "expiredAt": 1710243931,
      "checkoutUrl": "https://i.ccpayment.com/1djqz1m",
      "paidList": [
        {
          "recordId": "20240312090316119190942031876096",
          "fromAddress": "0x12438f04093ebc87f0ba629bbe93f2451711d967",
          "amount": "0.001",
          "serviceFee": "0.0000003",
          "txid": "0xef4abf7175cefbe2f06002a959892e4b407bef02175980eaa9bb1967fcba1b22",
          "status": "Success",
          "arrivedAt": 1710234197,
          "rate": "1.1692"
        }
      ]
    }  
  }`,
    go: {
      http_ex_code: `package main
  
  import (
  "bytes"
  "crypto/hmac"
  "crypto/sha256"
  "encoding/hex"
  "fmt"
  "io"
  "net/http"
  "time"
  )
  
  func main() {
  
  appId := "*** your appId ***"
  appSecret := "*** your appSecret ***"
  
  // With request params
  
  path := "${APP_ORDERRECORD_}"
  args := []byte(${`{
    "orderId": "1709889675"
  }`})
  
  //sign
  timestamp := time.Now().Unix()
  
  signText := fmt.Sprintf("%s%d", appId, timestamp)
  if len(args) != 0 {
      signText = fmt.Sprintf("%s%s", signText, args)
  }
  
  h := hmac.New(sha256.New, []byte(appSecret))
  h.Write([]byte(signText))
  sign := hex.EncodeToString(h.Sum(nil)[:])
  
  fmt.Printf("Sign: %s", sign)
  
  // Making API call
  client := http.Client{}
  request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
  request.Header.Set("Appid", appId)
  request.Header.Set("Sign", sign)
  request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
  resp, _ := client.Do(request)
  
  defer resp.Body.Close()
  respBytes, _ := io.ReadAll(resp.Body)
  fmt.Printf("Resp: %s", respBytes)
  }    
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${APP_ORDERRECORD_}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("orderId", "1709889675");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
        responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
        tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
        hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${APP_ORDERRECORD_}"
  content = {
      "orderId": "1709889675"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
      sign_text = f"{sign_text}{body}"
  else:
      body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  const orderId = "your_order_id";
  
  const path = "${APP_ORDERRECORD_}";
  const args = JSON.stringify({
    "orderId":"1709889675"
  });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
    $app_id = "*** your app_id ***";
    $app_secret = "*** your app_secret ***";
    $url = "${APP_ORDERRECORD_}";
    $content = [ "orderId"=> "1709889675"];
  
    $timestamp = time();
    $body = json_encode($content);
    $sign_text = $app_id . $timestamp;
    if (strlen($body) != 2) {
        $sign_text = $sign_text . $body;
    } else {
        $body = "";
    }
  
    $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
    $data = array(
        "headers" => array(
            "Content-Type: application/json;charset=utf-8",
            "Appid: " . $app_id,
            "Sign: " . $server_sign,
            "Timestamp: " . $timestamp
        ),
        "body" => $body
    );
  
    $ch = curl_init();
    curl_setopt($ch, CURLOPT_URL, $url);
    curl_setopt($ch, CURLOPT_POST, true);
    curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
    curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
    $response = curl_exec($ch);
    curl_close($ch);
  
    $result = json_decode($response, true);
    print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const or_create_app_deposit_address = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "address": "0x7C631947c139F0163fECc0eef39f251D72dAE3B8",
      "memo": ""
    }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
  
    path := "${CREATE_APP_DEPOSIT__ADDRESS_}"
    args := []byte(${'`{"referenceId": "testreferenceid1111","chain": "POLYGON"}`'})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }    
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${CREATE_APP_DEPOSIT__ADDRESS_}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("referenceId", "testreferenceid1111");
    map.put("chain", "POLYGON");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
        responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
      tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
      hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${CREATE_APP_DEPOSIT__ADDRESS_}"
  content = {
    "referenceId": str(int(time.time())),
    "chain": "POLYGON"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
      sign_text = f"{sign_text}{body}"
  else:
      body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
        "Content-Type": "application/json;charset=uf8",
        "Appid": app_id,
        "Sign": server_sign,
        "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  
  const path = "${CREATE_APP_DEPOSIT__ADDRESS_}";
  const args = JSON.stringify({
    "referenceId": String(Math.floor(Date.now() / 1000)), 
    "chain": "POLYGON",  
  });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
    $app_id = "*** your app_id ***";
    $app_secret = "*** your app_secret ***";
    $url = "${CREATE_APP_DEPOSIT__ADDRESS_}";
    $content = [  "referenceId"=> "345556788",
        "chain"=> "POLYGON"];
  
    $timestamp = time();
    $body = json_encode($content);
    $sign_text = $app_id . $timestamp;
    if (strlen($body) != 2) {
        $sign_text = $sign_text . $body;
    } else {
        $body = "";
    }
  
    $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
    $data = array(
        "headers" => array(
            "Content-Type: application/json;charset=utf-8",
            "Appid: " . $app_id,
            "Sign: " . $server_sign,
            "Timestamp: " . $timestamp
        ),
        "body" => $body
    );
  
    $ch = curl_init();
    curl_setopt($ch, CURLOPT_URL, $url);
    curl_setopt($ch, CURLOPT_POST, true);
    curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
    curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
    $response = curl_exec($ch);
    curl_close($ch);
  
    $result = json_decode($response, true);
    print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const deposit_record = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "record": {
        "recordId": "20240722062311166985855493492736",
        "orderId": "1721629226",
        "coinId": 1329,
        "coinSymbol": "MATIC",
        "chain": "POLYGON",
        "contract": "137",
        "coinUSDPrice": "0.537961",
        "fromAddress": "0xbf5e3c7afbe37d13b040adb11d497bdbe061c87b",
        "toAddress": "0xcf6689c1e6f7151a0e05510570e78a3fc7c1339d",
        "toMemo": "",
        "amount": "0.2",
        "serviceFee": "0.00006",
        "txId": "0x26f9794579566f9a1d056948d2dad725da32611604f9044202a099fdf9e5de45",
        "status": "Success",
        "arrivedAt": 1721629393
      }
    }
  }`,
    go: {
      http_ex_code: `package main
  
      import (
          "bytes"
          "crypto/hmac"
          "crypto/sha256"
          "encoding/hex"
          "fmt"
          "io"
          "net/http"
          "time"
      )
      
      func main() {
      
          appId := "*** your appId ***"
          appSecret := "*** your appSecret ***"
      
          // With request params
      
          path := "${APP_DEPOSIT__RECORD_}"
          args := []byte(${'`{"recordId": "20240227070332114087378078994432"}`'})
      
          //sign
          timestamp := time.Now().Unix()
      
          signText := fmt.Sprintf("%s%d", appId, timestamp)
          if len(args) != 0 {
              signText = fmt.Sprintf("%s%s", signText, args)
          }
      
          h := hmac.New(sha256.New, []byte(appSecret))
          h.Write([]byte(signText))
          sign := hex.EncodeToString(h.Sum(nil)[:])
      
          fmt.Printf("Sign: %s", sign)
      
          // Making API call
          client := http.Client{}
          request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
          request.Header.Set("Appid", appId)
          request.Header.Set("Sign", sign)
          request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
      
          resp, _ := client.Do(request)
      
          defer resp.Body.Close()
          respBytes, _ := io.ReadAll(resp.Body)
          fmt.Printf("Resp: %s", respBytes)
      }
      
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
      String appId = "*** your appId ***";
      String appSecret = "*** your appSecret ***";
      // With request params
      String path = "${APP_DEPOSIT__RECORD_}";
  
      // params
      Map<String, Object> map = new HashMap<>();
      map.put("recordId", "20240227070332114087378078994432");
  
      ObjectMapper mapper = new ObjectMapper();
      mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
      String inputString = mapper.writeValueAsString(map);
  
      byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
      // Sign
      long timestamp = new Date().getTime() / 1000L;
      String signText = appId + timestamp;
      if (requestBody.length != 0) {
          signText += new String(requestBody, StandardCharsets.UTF_8);
      }
      Mac sha256Hmac = Mac.getInstance("HmacSHA256");
      SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
      sha256Hmac.init(secretKey);
      byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
      String sign = byteArrayToHexString(signBytes);
  
      // Making API call
      HttpClient client = HttpClientBuilder.create().build();
      HttpPost request = new HttpPost(path);
      request.setHeader("Appid", appId);
      request.setHeader("Sign", sign);
      request.setHeader("Timestamp", String.valueOf(timestamp));
      request.setEntity(new ByteArrayEntity(requestBody));
      HttpResponse response = client.execute(request);
      BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
      StringBuilder responseText = new StringBuilder();
      String line;
      while ((line = reader.readLine()) != null) {
          responseText.append(line);
      }
      reader.close();
  
      // result
      System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
      StringBuilder hs = new StringBuilder();
      String tempStr;
      for (int index = 0; bytes != null && index < bytes.length; index++) {
          tempStr = Integer.toHexString(bytes[index] & 0XFF);
          if (tempStr.length() == 1)
              hs.append('0');
          hs.append(tempStr);
      }
      return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${APP_DEPOSIT__RECORD_}"
  content = {
    "recordId": "20240227070332114087378078994432"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
  headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
  data=body
  )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  
  const path = "${APP_DEPOSIT__RECORD_}";
  const args = JSON.stringify({
    "recordId": "20240227070332114087378078994432" 
  });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${APP_DEPOSIT__RECORD_}";
  $content = [ "recordId"=> "20240227070332114087378078994432"];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
        "Content-Type: application/json;charset=utf-8",
        "Appid: " . $app_id,
        "Sign: " . $server_sign,
        "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const deposit_record_list = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "records": [
        {
          "recordId": "20240722062311166985855493492736",
          "orderId": "1721629226",
          "coinId": 1329,
          "coinSymbol": "MATIC",
          'chain': "POLYGON",
          "contract": "137",
          "coinUSDPrice": "0.537961",
          "fromAddress": "0xbf5e3c7afbe37d13b040adb11d497bdbe061c87b",
          "toAddress": "0xcf6689c1e6f7151a0e05510570e78a3fc7c1339d",
          "toMemo": "",
          "amount": "0.2",
          'serviceFee': "0.00006",
          "txId": "0x26f9794579566f9a1d056948d2dad725da32611604f9044202a099fdf9e5de45",
          'status': "Success",
          'arrivedAt': 1721629393,
        },
      ],
      'nextId': "",
    },
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
  
    path := "${APP_DEPOSIT__RECORD_LIST_}"
    args := []byte(${"``"})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }    
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${APP_DEPOSIT__RECORD_LIST_}";
  
    // params
    byte[] requestBody = "".getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
        responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
        tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
        hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${APP_DEPOSIT__RECORD_LIST_}"
  content = {}
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
        "Content-Type": "application/json;charset=uf8",
        "Appid": app_id,
        "Sign": server_sign,
        "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  
  const path = "${APP_DEPOSIT__RECORD_LIST_}";
  const args = "";
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
    $app_id = "*** your app_id ***";
    $app_secret = "*** your app_secret ***";
    $url = "${APP_DEPOSIT__RECORD_LIST_}";
    $content = [];
  
    $timestamp = time();
    $body = json_encode($content);
    $sign_text = $app_id . $timestamp;
    if (strlen($body) != 2) {
        $sign_text = $sign_text . $body;
    } else {
        $body = "";
    }
  
    $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
    $data = array(
        "headers" => array(
            "Content-Type: application/json;charset=utf-8",
            "Appid: " . $app_id,
            "Sign: " . $server_sign,
            "Timestamp: " . $timestamp
        ),
        "body" => $body
    );
  
    $ch = curl_init();
    curl_setopt($ch, CURLOPT_URL, $url);
    curl_setopt($ch, CURLOPT_POST, true);
    curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
    curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
    $response = curl_exec($ch);
    curl_close($ch);
  
    $result = json_decode($response, true);
    print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <div>
      {/* 创建订单收款地址  充值相关API*/}
      <ContentWrap
        id="deposit-apis"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0" id="create-deposit-address-for-order">
              {translate("merchant_app_mode_API.text_8")}
            </Box>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_9")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_10")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_11")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_APP_AORDER_EPOSIT_ADDRESS} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_app_mode_API.text_12")}`,
                },
                {
                  name: "fiatId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc:
                    currentLang?.value === "en" ? (
                      <div>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${translate(
                              "merchant_app_mode_API.text_13"
                            )} ` as any,
                          }}
                        />
                        <Trans
                          i18nKey={"merchant_app_mode_API.text_13_"}
                          t={translate as any}
                        >
                          s
                          <a href={"#get-fiat-list"} className="link">
                            Just a placeholder
                          </a>
                        </Trans>
                      </div>
                    ) : (
                      <div>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${translate(
                              "merchant_app_mode_API.text_13"
                            )} ` as any,
                          }}
                        />
                        <Trans
                          i18nKey={"merchant_app_mode_API.text_13_"}
                          t={translate as any}
                        >
                          s
                          <a href={"#get-fiat-list"} className="link">
                            Just a placeholder
                          </a>
                        </Trans>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${translate(
                              "merchant_app_mode_API.text_13_1"
                            )} ` as any,
                          }}
                        />
                      </div>
                    ),
                },
                {
                  name: "price",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_14"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "_text_44" : "text_44"
                    }`
                  ),
                },
                {
                  name: "expiredAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <Trans
                      i18nKey={"merchant_app_mode_API.text_16"}
                      t={translate as any}
                    >
                      s<strong>s</strong>
                      <strong>s</strong>
                      <strong>s</strong>s
                    </Trans>
                  ),
                },
                {
                  name: "buyerEmail",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_app_mode_API.text_17")}`,
                },
                {
                  name: "generateCheckoutURL",
                  type: "Boolean",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_18"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "product",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_app_mode_API.text_19")}`,
                },
                {
                  name: "returnUrl",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_20"
                        )} ` as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={app_order_deposit_address[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 创建订单收款地址 返回*/}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.amount",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_21")}`,
                },
                {
                  name: "data.address",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_22")}`,
                },
                {
                  name: "data.memo",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_23")}`,
                },
                {
                  name: "data.checkoutUrl",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_24")}`,
                },
                {
                  name: "data.confirmsNeeded",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_25")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["app_order_deposit_address"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* Webhook 通知 - API Deposit */}
      <ContentWrap
        id="webhook-for-api-deposit"
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_27")}
            </Box>

            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"merchant_app_mode_API.text_28"}
                t={translate as any}
              >
                Just a placeholder
                <a href={"#get-order-information"} className="link">
                  Just a placeholder
                </a>
              </Trans>
            </Box>

            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_49")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "type",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_116"),
                },
                {
                  name: "msg",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "msg.recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "msg.orderId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_29")}`,
                },
                {
                  name: "msg.coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "msg.coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "msg.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_9"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "ApiDeposit",
  "msg": {
    "recordId": "20240313121919...",
    "orderId": "202403131218361...",
    "coinId": 1329,
    "coinSymbol": "POL",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取充值订单信息 */}
      <ContentWrap
        id="get-order-information"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_30")}
            </Box>

            <Box component={"div"} className="desc">
              {translate("merchant_app_mode_API.text_31")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_ORDERRECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_app_mode_API.text_88")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={app_order_info[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />

      {/* 获取充值订单信息 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.amountToPay",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_21")}`,
                },
                {
                  name: "data.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_32")}`,
                },
                {
                  name: "data.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_33")}`,
                },
                {
                  name: "data.chain",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_34")}`,
                },
                {
                  name: "data.toAddress",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_35")}`,
                },
                {
                  name: "data.toMemo",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_36")}`,
                },
                {
                  name: "data.fiatId",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_37")}`,
                },
                {
                  name: "data.fiatSymbol",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_38")}`,
                },
                {
                  name: "data.rate",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_39")}`,
                },
                {
                  name: "data.createAt",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_40")}`,
                },
                {
                  name: "data.expiredAt",
                  type: "Integer",
                  desc: (
                    <Trans
                      i18nKey={"merchant_app_mode_API.text_41"}
                      t={translate as any}
                    >
                      s<strong>s</strong>
                      <strong>s</strong>
                      <strong>s</strong>s
                    </Trans>
                  ),
                },
                {
                  name: "data.checkoutUrl",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_42")}`,
                },

                {
                  name: "data.buyerEmail",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_43")}`,
                },

                {
                  name: "data.paidList",
                  type: "Array",
                  desc: `${translate("merchant_app_mode_API.text_44")}`,
                },
                {
                  name: "data.paidList[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.paidList[index].fromAddress",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_45")}`,
                },
                {
                  name: "data.paidList[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.paidList[index].serviceFee",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_46")}`,
                },
                {
                  name: "data.paidList[index].txid",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.paidList[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_15"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.paidList[index].arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_47")}`,
                },
                {
                  name: "data.paidList[index].rate",
                  type: "String",
                  desc: (
                    <div
                      className="code"
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_48"
                        )} ` as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["app_order_info"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />

      <InvoiceAPI />

      {/* 创建或获取永久收款地址 */}
      <ContentWrap
        id="get-permanent-deposit-address"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("merchant_app_mode_API.text_49")}
            </Box>
            <Box className="desc">
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: `${translate(
                    "merchant_app_mode_API.text_50"
                  )} ` as any,
                }}
              />
            </Box>
            {currentLang?.value === "en" ? (
              <Box>
                <Box className="desc">
                  {translate("merchant_app_mode_API.text_89")}
                </Box>
                <Box
                  sx={{
                    ul: {
                      paddingLeft: "2em",
                    },
                    li: {
                      "::marker": {
                        textIndent: "2em",
                      },
                    },
                  }}
                >
                  <ul>
                    <li>
                      <Box component={"div"} className="desc">
                        {translate("merchant_app_mode_API.text_90")}
                      </Box>
                    </li>
                    <li>
                      <Box component={"div"} className="desc">
                        {translate("merchant_app_mode_API.text_91")}
                      </Box>
                    </li>
                  </ul>
                  <Box component={"div"} className="desc">
                    <Trans
                      i18nKey={"merchant_app_mode_API.text_91_"}
                      t={translate as any}
                    >
                      Just a placeholder
                      <Link
                        href={TELEGRAM_SUPPORT_URL}
                        target="_blank"
                        className="link"
                        underline="always"
                      >
                        Just a placeholder
                      </Link>
                    </Trans>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box>
                <Box className="desc">
                  {translate("merchant_app_mode_API.text_51")}
                </Box>
                <Box component={"div"} className="desc">
                  <Trans
                    i18nKey={"merchant_app_mode_API.text_51_"}
                    t={translate as any}
                  >
                    Just a placeholder
                    <Link
                      href={TELEGRAM_SUPPORT_URL}
                      target="_blank"
                      className="link"
                      underline="always"
                    >
                      Just a placeholder
                    </Link>
                  </Trans>
                </Box>
              </Box>
            )}

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_APP_DEPOSIT__ADDRESS} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "referenceId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_app_mode_API.text_87")}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={or_create_app_deposit_address[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 创建或获取永久收款地址 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.address",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_52"),
                },
                {
                  name: "data.memo",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_53"),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["or_create_app_deposit_address"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* Webhook 通知 - Direct Deposit */}
      <ContentWrap
        id="webhook-for-direct-deposit"
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_54")}
            </Box>

            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"merchant_app_mode_API.text_55"}
                t={translate as any}
              >
                Just a placeholder
                <a href={"#get-deposit-record"} className="link">
                  Just a placeholder
                </a>
              </Trans>
            </Box>

            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_49")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "type",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_117"),
                },
                {
                  name: "msg",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "msg.recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "msg.referenceId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_56")}`,
                },
                {
                  name: "msg.coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "msg.coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "msg.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_9"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "DirectDeposit",
  "msg": {
    "recordId": "2024031311310811...",
    "referenceId": "63224704901...",
    "coinId": 1329,
    "coinSymbol": "MATIC",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取充值记录 */}
      <ContentWrap
        id="get-deposit-record"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_57")}
            </Box>
            <Box className="desc code">
              {translate("merchant_app_mode_API.text_58")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_DEPOSIT__RECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={deposit_record[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取充值记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.record.chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_36")}`,
                },
                {
                  name: "data.reocrd.contract",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_37")}`,
                },
                {
                  name: "data.record.coinUSDPrice",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_37_"
                  )}`,
                },
                {
                  name: "data.record.fromAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_17")}`,
                },
                {
                  name: "data.record.toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "data.record.toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.record.serviceFee",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_46")}`,
                },
                {
                  name: "data.record.txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_24")}`,
                },
                {
                  name: "data.record.referenceId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_59")}`,
                },
                {
                  name: "data.record.orderId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_60")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_96"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["deposit_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />

      {/* 获取充值记录列表 Get Deposit Record List */}
      <ContentWrap
        id="get-deposit-record-list"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("merchant_app_mode_API.text_61")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_62")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_DEPOSIT__RECORD_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "referenceId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_app_mode_API.text_87")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_app_mode_API.text_64"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },

                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang?.value === "en" ? "text_32" : "text_31"
                    }`
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={deposit_record_list[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取充值记录列表  返回*/}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: "",
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.records[index].chain",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_65")}`,
                },
                {
                  name: "data.record[index].contract",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_37")}`,
                },

                {
                  name: "data.record[index].coinUSDPrice",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_37_"
                  )}`,
                },

                {
                  name: "data.records[index].fromAddress",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_45")}`,
                },
                {
                  name: "data.records[index].toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "data.records[index].toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.records[index].serviceFee",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_46")}`,
                },
                {
                  name: "data.records[index].txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_47")}`,
                },
                {
                  name: "data.records[index].referenceId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_59")}`,
                },
                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_60")}`,
                },
                {
                  name: "data.nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            `merchant_user_wallet_mode_API.${
                              currentLang?.value === "en"
                                ? "text_32"
                                : "text_30_"
                            }`
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["deposit_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
